import { render } from "./Desktop.vue?vue&type=template&id=5deb146e&scoped=true"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=5deb146e&scoped=true&lang=css"
import "./Desktop.vue?vue&type=style&index=1&id=5deb146e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deb146e"]])

export default __exports__